module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ThinItalic-5e88a618e69408313b84a5fe20152636.ttf";